<template>
	<!-- v-bind="$attrs" 所有其他参数按照官网绑定 -->
	<el-dialog
		:visible="visible"
		custom-class="app-dialog"
		:title="title"
		:width="offsetType === 'table' ? tableWidth : width"
		:before-close="handleClose"
		:top="top"
		v-bind="$attrs"
		:close-on-click-modal="false"
		:class="offsetType === 'table' ? 'left_dialog' : ''"
		v-on="$listeners"
	>
		<div :class="dialogType === 'normal' ? 'dialog_content' : ''">
			<slot></slot>
		</div>
		<template #footer>
			<div class="dialog_footer">
				<slot name="footer" />
			</div>
		</template>
		<!-- <span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleConfirm">确 定</el-button>
		</span> -->
	</el-dialog>
</template>

<script>
export default {
	name: "MyDialog",
	model: {
		prop: "visible",
		event: "update:visible"
	},
	props: {
		title: String,
		width: {
			type: String,
			default: "60%"
		},
		visible: {
			type: Boolean,
			required: true
		},
		dialogType: {
			type: String,
			default: "normal"
		},
		offsetType: {
			type: String,
			default: ""
		},
		tableWidth: {
			type: String,
			default: "90%"
		},
		top: {
			type: String,
			default: "10vh"
		},
		closeImmediate: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClose() {
			if (this.closeImmediate) {
				this.$emit("update:visible", false);
			} else {
				this.$confirm("确认关闭？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				})
					.then(() => {
						this.$emit("update:visible", false);
					})
					.catch(() => {});
			}
			// this.$emit('update:visible', false);
		},
		handleConfirm() {
			this.$emit("confirm");
			this.handleClose();
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.dialog_content {
	min-height: calc(100vh - 29.125rem);
	padding: 0;
}

.left_dialog {
	// margin: 0 0 0 120px;
	margin: 0 auto;
}

.dialog_footer {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
	padding: 10px 14px 14px;
	border-top: 1px solid #e7ebf3;
}
</style>
